import { DatePeriod, DatePeriodSchema } from "@greeter/date";
import { TableId, TableIdSchema } from "./Table";
import * as z from "zod";

export const LockedTableSchema = z.object({
  table: TableIdSchema,
  period: DatePeriodSchema,
});
export type LockedTable = z.infer<typeof LockedTableSchema>;
